import { CloseButton } from '~/components/elements/CloseButton'
import { WEARAppIconWithoutBorder } from '~/components/icons/generated/WEARAppIconWithoutBorder'

type Props = {
  onCloseClick?: () => void
  text: string
}

export const LoginDialog: React.FC<Props> = ({ onCloseClick, text }) => (
  <div className="relative flex w-[315px] flex-col items-center rounded-[4px] bg-white pb-8 pt-10 xl:w-[531px] xl:rounded-[16px] xl:py-12">
    <CloseButton
      className="absolute right-[9px] top-[9px] flex p-[6px] text-[16px] xl:right-5 xl:top-[18px] xl:text-[22px]"
      onClick={onCloseClick}
    />
    <WEARAppIconWithoutBorder className="size-[72px] drop-shadow-[0_0_5px_rgba(0,0,0,0.1)] xl:size-[80px]" />
    <p className="whitespace-pre-line pt-5 text-center text-[14px] leading-normal xl:pt-6 xl:text-[18px] xl:font-bold">
      {text}
    </p>
    <p className="flex flex-col items-center gap-y-3 pt-6 xl:gap-y-4">
      <a
        href="/login"
        className="block w-[262px] rounded-full bg-blue-400 py-4 text-center text-[14px] font-bold leading-none text-white xl:w-[280px] xl:text-[16px]"
      >
        ログインする
      </a>
      <a
        href="/sign_up"
        className="block w-[262px] rounded-full border border-blue-400 bg-white py-4 text-center text-[14px] font-bold leading-none text-blue-400 xl:w-[280px] xl:text-[16px]"
      >
        新規会員登録する
      </a>
    </p>
  </div>
)
